import React from 'react'
import fetchApi from './fetchApi'

const MenuContext = React.createContext([])

/**
 * 메뉴 API 사용을 위한 Provider
 */
export function MenuProvider(props) {
  const [menus, setMenus] = React.useState([])

  React.useEffect(() => {
    fetchApi('/system/menu/user/root-mobile-react').then(data => {
      setMenus(data)
      Promise.all(
        data.map(menu =>
          fetchApi('/system/menu/user/mobile-react', {
            body: new URLSearchParams({key: menu.HTMFILE}),
          }),
        ),
      ).then(subMenus => {
        const menuWithSub = data.map((menu, i) => ({
          ...menu,
          subMenu: subMenus[i],
        }))
        setMenus(menuWithSub)
      })
    })
  }, [])

  return <MenuContext.Provider value={menus}>{props.children}</MenuContext.Provider>
}

/**
 * 메뉴API 데이터 사용
 * @typedef {{HTMFILE:string,MENU_NAM:string,ENAME:string,KNAME:string}} MenuObject
 * @typedef {{HTMFILE:string,MENU_NAM:string,ENAME:string,KNAME:string,subMenu:MenuObject[]}} RootMenuObject
 * @returns {RootMenuObject[]}
 */
export function useMenus() {
  const menus = React.useContext(MenuContext)
  return menus
}
